import { render, staticRenderFns } from "./ProgramTab.vue?vue&type=template&id=0fca1de4&scoped=true"
import script from "./ProgramTab.vue?vue&type=script&lang=js"
export * from "./ProgramTab.vue?vue&type=script&lang=js"
import style0 from "./ProgramTab.vue?vue&type=style&index=0&id=0fca1de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca1de4",
  null
  
)

export default component.exports